import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';
import { RentalObjectInfo } from 't4core';


@Component({
    selector: 'fle-editObjectDialog',
    templateUrl: 'editObjectDialog.html',
})
export class T4_EditObjectDialog extends DialogBase {
    public id: number;

    public title: string = "";
    public alias: string = "";
    public type: string = "340";

    constructor(
        public dialogRef: MatDialogRef<T4_EditObjectDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("EditObjectDialog");

        this.id = data;
        if (this.id) {
            this.Api.get<RentalObjectInfo>("RentalObject/GetObjectInfo", { objectId: this.id }).then(x => {
                this.title = x.Title;
                this.alias = x.Alias;
                this.type = "" + x.Type.Id;
            });
        }
    }

    public save() {
        if (!this.title || this.title == '') return;
        if (!this.alias || this.alias == '') return;
        if (!this.type || this.type == '') return;

        if (this.id) {
            this.Api.post<any>("RentalObject/UpdateOneWayObject", null, { obj: this.id, title: this.title, alias: this.alias, typeId: this.type }).then(x => {
                this.dialogRef.close();
            }).catch(x => {
                alert("Failed!");
            });
        } else {
            this.Api.post<any>("RentalObject/AddOneWayObject", null, { title: this.title, alias: this.alias, typeId: this.type }).then(x => {
                this.dialogRef.close();
            }).catch(x => {
                alert("Failed!");
            });
        }

    }
}
